import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {
  AddressChangeRequest,
  ChangeRequestHistoryEntry,
  ChangeRequestData
} from '../../models/change-requests';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { InstanceTypes } from '../../models/instance-types';
import { ChangeRequestService } from '../../services/change-request.service';

@Component({
  selector: 'lib-address-change-review-modal',
  templateUrl: './address-change-review-modal.component.html',
  styleUrls: ['./address-change-review-modal.component.css'],
  standalone: false
})
export class AddressChangeReviewModalComponent implements OnInit {
  @Input()
  public addressChangeRequestData: ChangeRequestData<AddressChangeRequest>;
  @Input()
  public changeRequest: ChangeRequestHistoryEntry;
  @Input()
  public readonly: boolean;
  @ViewChild('addressChangeReviewModal', { static: true })
  public modalContent: TemplateRef<any>;

  private modalRef: NgbModalRef;

  @Output('modalClosed')
  public modalClosed = new EventEmitter<{
    Operation: 'accept' | 'decline' | 'dismiss' | 'cancel';
    Result: boolean;
  }>();
  get isEmployeePortal() {
    return this.env.instanceType == InstanceTypes.EmployeePortal;
  }
  constructor(
    private ngModalService: NgbModal,
    @Inject('env') private env: any,
    private changeRequestService: ChangeRequestService
  ) {}

  ngOnInit() {
    this.modalRef = this.ngModalService.open(this.modalContent, {
      size: 'md',
      windowClass: 'centered',
      backdrop: 'static',
      keyboard: false
    });
    this.modalRef.result.then(
      // close
      result => {},
      // dismiss
      () => this.modalClosed.emit({ Operation: 'dismiss', Result: false })
    );
  }

  public cancelAddressRequest() {
    this.changeRequestService
      .cancelOpenAddressRequest(this.changeRequest.ClientCode, this.changeRequest.PersonId)
      .subscribe(_ => {
        this.modalClosed.emit({ Operation: 'cancel', Result: true });
        this.modalRef.close();
      });
  }
}
